<template>
  <div id="app">
    <router-view /> 
    <!-- <index :value="100"  :title="'车速'" :width="200" :type="'consumptionPer100km_eng'" :showInCenter="true" /> -->
  </div>
</template>
<script>
// import index from "@/views/vmonitor/speedlimit/index.vue" //限速控制
// import index from "@/views/vmonitor/speedlimit/hightlimit.vue" //最高限速控制
// import index from "@/views/vmonitor/speedlimit/arealimit.vue" //区域限速
// import index from "@/views/vmonitor/speedlimit/time_speed_set.vue" //夜间限速
// import index from "@/views/vmonitor/speedlimit/tired_limit_speed_set.vue" //疲劳驾驶限速
// import index from "@/views/vmonitor/VehiclePhotoMgr/VehiclePhotoCapture.vue" //图片抓拍
// import index from "@/views/vmonitor/VedioMonitor/VedioMonitorMgr.vue" //视频监控
// import index from "@/views/statistics/operationalData/index.vue" //运行数据
// import index from "@/views/driver/drivingScores/index.vue" //驾驶评分
// import index from "@/views/statistics/chronology/index.vue" //工作年表
// import index from "@/views/maintenance/transactionReminder/index.vue" //事务提醒
// import index from "@/views/maintenance/upkeep/index.vue" //保养登记
// import index from "@/views/maintenance/yearlyOrQuarter/index.vue" //运营证年检/季检登记
// import index from "@/views/maintenance/annualInspection/index.vue" //年检登记
// import index from "@/views/login/index.vue" //
// import index from "@/components/KLVehicleSelect" //
// import index from "@/views/demo/map" //
import index from "@/views/demo/pdf" //
// import index from "@/components/KLGauge" //

// import index from "@/views/statistics/vehicleReport/index" //
// import index from "@/components/KLVideo/index" //
// import index from "@/components/KLVideo/VideoPlay"; //

// import index from "@/views/vmonitor/locateVehicle/VehicleDashboard" //

// import index from "@/views/demo/tree" //
// import index from "@/views/statistics/socchange/index" //

// import index from "@/views/statistics/speedcharts/index" //

// import index from "@/views/basicmanagement/driverManagement/index.vue"
// import index from "@/views/maintenancemanagement/accidentManagement/index.vue"
// import {bd09togcj02,gcj02tobd09,wgs84togcj02} from "@/utils/lnglat"
export default {
  components: {
    index,
  },
  data() {
    return {
      videoPlayer: {
        videoId: "sdfsdf",
        canvasId: "sdfsdf11",
        // src: "https://www.kingwings.cn:7205/live/00140401000001.live.flv",
        src: "https://replay3.kingwings.cn/live/004011000368-1",
        setPromptWord(key) {
          console.log("设置提示词", key);
        },
        VideoPlay: {
          destroy() {
            console.log("destroy");
          },
        },
      },
    };
  },
  mounted() {
    // console.log(wgs84togcj02(117.983248,24.591644))
    // this.$refs.index.load();
  },
};
</script>
<style>
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
</style>
